import { SVG, IconProps } from "../SVG";
import React from "react";

export const QuestionBubble = ({
    spotColor = "#E4EDFE",
    color = "#13126C",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 27 23" {...props}>
        <path
            fill={spotColor}
            fillRule="evenodd"
            d="M0 10.316C0 4.55 5.036 0 11.09 0c6.052 0 11.089 4.55 11.089 10.316 0 2.333-.833 4.48-2.224 6.199l.284 4.752a.861.861 0 0 1-.425.796.847.847 0 0 1-.897-.027l-3.396-2.26c-1.36.552-2.859.857-4.432.857C5.036 20.633 0 16.083 0 10.316Z"
            clipRule="evenodd"
        />
        <path
            fill={color}
            d="M14.876 13.98a.768.768 0 0 1-.768-.755v-.302c-.056-1.646 1.076-2.36 1.9-2.881.893-.563 1.396-.933 1.396-1.934 0-1.276-.95-2.1-2.416-2.1-.35.014-1.983.193-1.983 2.086a.768.768 0 0 1-1.536 0c0-2.785 2.29-3.567 3.491-3.594h.014c2.332 0 3.966 1.481 3.966 3.608 0 1.879-1.215 2.647-2.095 3.21-.823.521-1.214.81-1.187 1.564v.343a.78.78 0 0 1-.782.754Z"
        />
        <ellipse cx={14.946} cy={16.009} fill={color} rx={0.88} ry={0.864} />
        <path
            fill={color}
            fillRule="evenodd"
            d="M15.24 1.749c-5.376 0-9.602 3.908-9.602 8.574 0 4.667 4.226 8.574 9.601 8.574 1.536 0 2.983-.321 4.265-.89a.887.887 0 0 1 .84.066l2.41 1.563-.206-3.37a.848.848 0 0 1 .215-.616c1.307-1.47 2.078-3.32 2.078-5.327 0-4.666-4.226-8.574-9.602-8.574ZM3.891 10.323C3.892 4.572 9.046.034 15.24.034c6.193 0 11.347 4.538 11.347 10.29 0 2.326-.852 4.466-2.275 6.181l.29 4.74a.854.854 0 0 1-.435.794.886.886 0 0 1-.918-.027l-3.475-2.254a12.32 12.32 0 0 1-4.535.854c-6.193 0-11.347-4.538-11.347-10.289Z"
            clipRule="evenodd"
        />
    </SVG>
);
QuestionBubble.displayName = "QuestionBubble";
